import relativesTemplate from './relatives.html';

// Search location form settings (IDs from locationLookup.directive.html)
const SEARCH_LOCATION_FORM_ID = 'form-location-search';
const SEARCH_LOCATION_INPUT_ID = 'input-location-search';

const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';

export default angular
  .module('main.locations.edit.tabs.relatives', [])

  .directive('editLocationRelativesTab', () => {
    return {
      restrict: 'E',
      template: relativesTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $state,
                   utils,
                   $rootScope,
                   $filter,
                   I18nService,
                   PermissionsService,
                   EditLocationDataProvider) => {
        const $t = $filter('translate');

        $scope.allOrgs = utils.getStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY);

        $scope.dataProvider = EditLocationDataProvider.instance;
        $scope.locale = I18nService.getLocale();
        $scope.newConnection = {
          searching: false,
          locations: [],
        };

        angular.extend($scope, {
          copyToClipboard: $rootScope.copyToClipboard,
          getLocationAddress: getLocationAddress,
          getLocationOrgName: getLocationOrgName,
          newSubLocation: newSubLocation,
          editLocation: editLocation,
          canEditLocation: canEditLocation,
          onRemoveConnectionButtonClick: onRemoveConnectionButtonClick,
          removeConnection: removeConnection,
          searchLocations: searchLocations,
          selectLocation: selectLocation,
          canCreateLocation: canCreateLocation,
          onAddConnectionButtonClick: onAddConnectionButtonClick,
          groupTotals: groupTotals,
          onAssignGroupButtonClick: onAssignGroupButtonClick,
          removeGroup: removeGroup,
        });

        // Remove Modals
        $scope.$on('$destroy', () => {
          $('#assign-group-modal').remove();
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.locationOrganizationResource.init(),
            $scope.dataProvider.locationIdResource.init(),
            $scope.dataProvider.locationResource.init(),
            $scope.dataProvider.locationRelativesResource.init(),
          ])
            .then(() => {
              $scope.hasFeatureG = utils.hasFeature($scope.dataProvider.locationOrganizationResource.value, 'g'); // Groups module enabled

              getLocationRelatives();
              initWatchers();

              if ($scope.hasFeatureG) {
                $q.all([
                  $scope.dataProvider.locationGroupsResource.init(),
                  $scope.dataProvider.availableGroupsResource.init(),
                ]).then(() => {
                  processGroups();
                });
              }
            });
        }

        function initWatchers() {
          $scope.$watch(() => $scope.dataProvider.locationRelativesResource.value, (newVal, oldVal) => {
            if (newVal !== oldVal) {
              getLocationRelatives();
            }
          }, true);
        }

        function getLocationRelatives() {
          $scope.relatives = angular.copy($scope.dataProvider.locationRelativesResource.value);
          $scope.currentLocation = angular.copy($scope.dataProvider.locationResource.value);
          $scope.searchLocationSubType = $scope.currentLocation.subType === 0 ? 1 : undefined;

          // Keep loading state until groups fetched
          $scope.loading = $scope.hasFeatureG ? true : false;
        }

        function processGroups() {
          $scope.groups = angular.copy($scope.dataProvider.locationGroupsResource.value || []);
          $scope.availableGroups = angular.copy($scope.dataProvider.availableGroupsResource.value || [])
            .filter(group => group.tag !== $scope.dataProvider.locationGroupsResource.value.find(g => g.tag === group.tag)?.tag);

          $scope.loading = false;
        }

        function getLocationAddress(location) {
          let address = utils.generateAddress(location);
          if (!address) {
            return $t('common.unknown-address');
          }
          return address;
        }

        function getLocationOrgName(location) {
          if (!location || !location.organizationId) {
            return $t('locations.list.notAtOrg');
          }
          let org = $scope.allOrgs.find(element => {
            return location.organizationId === element.id;
          });
          if (org && org.name) {
            return $t('locations.list.atOrg', { name: org.name });
          } else {
            return $t('common.unknownOrganization');
          }
        }

        function canEditLocation(location) {
          if (!location) {
            return false;
          }
          return PermissionsService.canIEditLocation(location);
        }

        function canCreateLocation() {
          return PermissionsService.canICreateLocation();
        }

        /**
         * Goto Edit location UI
         * @param location location to edit
         * @param {string} tabName tab name to open automatically
         */
        function editLocation(location, $event, tabName) {
          if ($scope.loading || !canEditLocation(location)) {
            return;
          }
          // If Location is not at any Organization
          if (!location.organizationId) {
            return;
          }
          utils.setStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY, location);
          $state.go('main.locations.edit', { locationId: location.id, tab: tabName });
        }

        function newSubLocation() {
          if (!canCreateLocation()) {
            return;
          }
          if ($scope.loading) {
            return;
          }
          utils.removeStorageItem('selected-location-id');
          $state.go('main.locations.new');
        }

        function searchLocations(searchTerm, globalSearch) {
          $scope.newConnection.searching = true;
          delete $scope.hideSearchHint;
          delete $scope.connectionExist;

          let subType = $scope.currentLocation.subType === 0 ? 1 : void 0;
          return $scope.dataProvider.searchLocations(searchTerm, globalSearch, subType)
            .then((locations) => {
              $scope.newConnection.locations = locations.filter(l => {
                let connectionExist = $scope.relatives.find(r => r.id === l.id);
                return !connectionExist;
              });
              $scope.newConnection.searching = false;
              return;
            }, err => {
              $scope.newConnection.locations = [];
              $scope.newConnection.searching = false;
              utils.handleApiError(err);
            });
        }

        function selectLocation(location) {
          if ($scope.loading || $scope.newConnection.searching || !location || !$scope.newConnection.locations || $scope.newConnection.locations.length === 0) {
            return;
          }

          $scope.loading = true;
          $scope.newConnection.searching = true;

          return $scope.dataProvider.addRelativeLocation(location)
            .then(() => {
              $scope.loading = false;
              $scope.newConnection.searching = false;
              $scope.newConnection.locations = $scope.newConnection.locations?.filter(l => l.id !== location.id);
            })
            .catch(err => {
              $scope.loading = false;
              $scope.newConnection.searching = false;
              utils.handleApiError(err);
            });
        }

        function onRemoveConnectionButtonClick(location) {
          $('#remove-connection-dialog').modal({
            closable: true,
            detachable: true,
            onApprove: function() {
              $('#remove-connection-dialog').modal('hide');
              removeConnection(location);
            }
          }).modal('show');
        }

        /**
         * Remove connection between locations
         * @param location location to remove relationship with
         */
        function removeConnection(location) {
          if ($scope.loading || !canEditLocation($scope.currentLocation)) {
            return;
          }

          $scope.loading = true;
          return $scope.dataProvider.removeRelativeLocation(location)
            .then(() => {
              $scope.loading = false;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function onAddConnectionButtonClick() {
          // Focus input inside of locationLookup directive
          $('#' + SEARCH_LOCATION_FORM_ID).form('clear');
          $('#' + SEARCH_LOCATION_INPUT_ID).trigger('focus');
        }

        function onAssignGroupButtonClick() {
          $('#assign-group-modal').modal({
            closable: true,
            detachable: true,
            onApprove: () => {
              $scope.$applyAsync(() => {
                assignGroups();
              });
            }
          }).modal('show');
        }

        function assignGroups() {
          if (!$scope.selectedGroupTags) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.addLocationGroups($scope.selectedGroupTags)
            .then(() => {
              processGroups();
            }, (err) => {
              $scope.loading = false;
            });
        }

        function removeGroup(group) {
          if (!group || group.tag === undefined) {
            return;
          }

          $scope.dataProvider.removeLocationGroup(group.tag)
            .then(() => {
              processGroups();
            }, (err) => {
              utils.handleApiError(err);
            });
        }

        function groupTotals(group) {
          let result = 0;

          if ($scope.dataProvider.availableGroupsResource.value) {
            let currentGroup = $scope.dataProvider.availableGroupsResource.value
              .find(g => g.tag === group.tag);
            result += currentGroup.total;
          }

          return result;
        }
      }
    };
  })
  .name;
